import React from "react";
import {
  SquarePaymentsForm,
  CreditCardInput,
} from "react-square-web-payments-sdk";
import { ButtonDanger } from "./buttons";
import "react-square-payment-form/lib/default.css";
import { Modal } from "react-bootstrap";
import { Box } from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";

export const DialogMessage = ({ title, body, onCancel, push }) => {
  React.useEffect(() => {
    if (push) {
      const rootWindow = window.parent;
      const prevX = rootWindow.scrollX;
      const prevY = rootWindow.scrollY;
      rootWindow.scrollTo(prevX, 0);
      return () => rootWindow.scrollTo(prevX, prevY);
    }
  });

  return (
    <Box className="centered">
      {push && (
        <Box className="dialog">
          <Box className="modal-dialog">
            <Box
              className="modal-content"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Box
                className="modal-header bg-danger text-white"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  className="modal-title"
                  style={{
                    color: "white",
                    height: "30px",
                    fontWeight: "700",
                    fontFamily: "Segoe UI",
                  }}
                >
                  {title}
                </Box>
                <CancelIcon
                  onClick={onCancel}
                  style={{ color: "white", cursor: "pointer", outline: "none" }}
                />
              </Box>
              <Box className="modal-body" style={{ flexGrow: 1 }}>
                {body}
              </Box>
              <Box height="1px" bgcolor="#dee2e6" width="100%"></Box>
              <Box style={{ textAlign: "right" }} p={2}>
                <ButtonDanger onClick={onCancel} text="OK" />
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export const ModalPayment = ({
  price,
  cardNonceResponseReceived,
  onCancel,
  team
}) => {
  React.useEffect(() => {
    const rootWindow = window.parent;
    const prevX = rootWindow.scrollX;
    const prevY = rootWindow.scrollY;
    rootWindow.scrollTo(prevX, 0);
    return () => rootWindow.scrollTo(prevX, prevY);
  });
  return (
    <Modal show={true} onHide={onCancel}>
      <Modal.Header className="bg-danger text-white">
        <Modal.Title>
          {" "}
          <span
            className="modal-title"
            style={{
              color: "white",
              height: "30px",
              fontWeight: "700",
              fontFamily: "Segoe UI",
              fontSize: "16px",
            }}
          >
            Payment
          </span>
        </Modal.Title>
        <CancelIcon
          onClick={onCancel}
          style={{ color: "white", cursor: "pointer", outline: "none" }}
        />
      </Modal.Header>
      <Modal.Body>
        <Box>Full price for this slot in team ${price} (AUD)</Box>
        <SquarePaymentsForm
          applicationId={team?.team_info?.pay_pub_key}
          cardTokenizeResponseReceived={(token) =>
            cardNonceResponseReceived(token)
          }
          locationId={team?.team_info?.pay_location}
        >
          <CreditCardInput text="Pay now" />
        </SquarePaymentsForm>
        {/* <SquarePaymentForm
          sandbox={false}
          applicationId={applicationId}
          locationId={locationId}
          cardNonceResponseReceived={cardNonceResponseReceived}
        >
          <fieldset className="sq-fieldset">
            <CreditCardNumberInput />
            <Box className="sq-form-third">
              <CreditCardExpirationDateInput />
            </Box>
            <Box className="sq-form-third">
              <CreditCardCVVInput />
            </Box>
          </fieldset>

          <CreditCardSubmitButton>Pay</CreditCardSubmitButton>
        </SquarePaymentForm> */}
      </Modal.Body>
    </Modal>
  );
};
